/**
 * Компонент, создающий лаеры.
 */

define('toolkit/b-layer/b-layer', function (require){
	'use strict';

	var $ = require('jquery'),
		toolkit = require('toolkit/b-toolkit/b-toolkit'),
		BControlsGroup = require('toolkit/b-controls-group/b-controls-group'),
		keymaster = require('toolkit-common/keymaster/keymaster');

	var _visible = [];

	var layers = toolkit.create('b-layer', 'b-controls-group', {
		bemName: 'b-layer',

		container: '.b-layer__container',
		wrapper:   '.b-layer__wrapper',
		bodyScrollbar: false,

		defaults: {
			canHide: true
		},

		/**
		*
		* Прерываем работу хоткеев, когда открыт попав
		* https://jira.mail.ru/browse/MAIL-47695
		* @param {Event} e
		* @private
		*/
		_preventHotkey: function(e) {
			if (e.keyCode !== 27) {
				e.stopPropagation();
			}
		},

		init: function () {
			this._onResize = toolkit.throttle(this._setContainerPosition, 200, this);
			toolkit['b-controls-group'].prototype.init.apply(this);
		},

		show: function(params) {
			if(_visible.length) {
				_visible[_visible.length - 1]._hide();
			}

			// вешаемся на клавиатурные сокращения (каждый раз, чтобы первып перехватить событие)
			keymaster('escape', layers.shortcut.bind(this));

			//https://jira.mail.ru/browse/MAIL-47695
			$(document.body).on('keydown', this._preventHotkey);


			this.params = params;
			this.render(params);

			this._show();

			if(_visible.length) {
				var prev = _visible[_visible.length - 1];

				if(prev.$el !== this.$el) {
					_visible.push(this);
				} else {
					_visible[_visible.length - 1] = this;
				}

			} else {
				_visible.push(this);
			}

			this.emit('show', params);

			return this;
		},

		_setContainerPosition: function() {

			// MAIL-50082
			// можем вызвать метод, тогда когда уже сработало this.close()
			// из-за того как работает toolkit.throttle
			// пример:
			// 1 вызываем событие 'resize'( вызывается этот метод)
			// 2 вызываем его еще раз (метод не вызывается)
			// 3 вызываем this.close() удаляется this.$el
			// 4 вызывается метод из 2, а элемент уже удален -> js exeption в this.$() так как this.$el === null
			if( !this.$el ) return;

			var $container = this.$(this.container),
				wrapperHeight = this.$(this.wrapper).height(),
				containerHeight = $container.height(),
				top = (wrapperHeight - containerHeight) / 2;

			if (top < 0 || containerHeight === 0) {
				top = 0;
			}

			$container.css('top', top + 'px');
		},

		// делаем слой видимым
		_show: function() {
			if( !this.bodyScrollbar ){
				var $div = $('<div style="overflow: scroll;"><div></div></div>').appendTo('body');

				$div.remove();
			}

			if (!_visible.length) {
				_visible.push(this);
			}

			this.$el.show();
			$(window).on('resize', this._onResize).trigger('resize');
		},

		// делаем слой невидимым
		_hide: function() {
			$(window).off('resize', this._onResize);
			$(document.body).off('keydown', this._preventHotkey);
			this.$el.hide();
		},

		// скрываем слой по клику на закрыть/отменить/esc
		hide: function() {
			if( this.canHide ){
				this._hide();

				_visible.pop();

				if(_visible.length) {
					_visible[_visible.length - 1]._show();
				}

				this.emit('hide');
			}

			return this;
		},

		// закрываем текущий слой и все остальные
		close: function() {
			this._hide();

			this.destroy();
			delete this.params;

			_visible = [];

			return this;
		},

		onClose: function(evt, ui) {
			this.hide();
		}
	});


	// статические методы класса
	$.extend(layers, {
		sel: '.layers',

		set: function(name, opts, params) {
			var cls = layers.extend(opts);

			var item = new cls({
				$el: $('<div style="display: none" />').appendTo(layers.sel),

				template:      opts.template      || layers.template,
				templateBlock: opts.templateBlock || layers.templateBlock,

				data: $.extend({
					block: opts.block || name

				}, params || {})
			});

			layers[name] = item.show.bind(item);

			return layers;
		},

		close: function() {
			_visible.forEach(function(layer) {
				layer.close();
			});

			return layers;
		},

		hide: function() {
			if(_visible.length) {
				_visible[_visible.length - 1].hide();
			}

			return layers;
		},

		shortcut: function (/** Event */evt) {
			if (_visible.length) {
				evt.preventDefault();
				evt.stopImmediatePropagation();

				layers.hide();

				this.emit('escape', {
					name: name
				});
			}
		}

	});

	keymaster.filter = function() {
		return true;
	};

	toolkit['b-layer'] = layers;

	// Export
	return toolkit['b-layer'];
});
